import fetchJSON from '@gaia/utils/fetchJSON';
import once from 'lodash/once';

const fetchSavedKnownRoutes = once(async function fetchSavedKnownRoutes(
    isAuthenticated: boolean
): Promise<Record<number, KnownRouteTag> | undefined> {
    if (!isAuthenticated) return [];

    try {
        const savedItems: ObjectsSavedItem[] = await fetchJSON('/api/objects/saveditem/');
        const savedKnownRoutes = savedItems.filter(
            (s): s is KnownRouteSavedItem => s.related_type === 'KnownRoute'
        );
        return savedKnownRoutes.map(toKnownRoute).reduce((acc, krt) => {
            return {...acc, [krt.id]: krt};
        }, {});
    } catch (e) {
        console.error(e);
        return [];
    }
});

export default fetchSavedKnownRoutes;

function toKnownRoute(savedItem: KnownRouteSavedItem): KnownRouteTag {
    const {kr_title: name} = savedItem.item_data;
    return {
        id: +savedItem.related_id,
        name,
        geometry: savedItem.item_data?.region?.geometry ?? {
            type: 'LineString',
            coordinates: [],
        },
        isSaved: true,
    };
}

type ObjectsSavedItem =
    | {
          archived: boolean;
          id: string;
          item_data: any;
          last_updated_on_server: string;
          notes: string | null;
          path: string;
          related_id: string;
          related_type: string;
          time_created: string;
          title: string;
      }
    | KnownRouteSavedItem;

type KnownRouteSavedItem = {
    archived: boolean;
    id: string;
    item_data: {
        kr_title: string;
        region: Region;
    };
    last_updated_on_server: string;
    notes: string | null;
    path: string;
    related_id: string;
    related_type: 'KnownRoute';
    time_created: string;
    title: string;
};
